import ajaxServiceByApiGateway from './ajaxServiceByApiGateway';

export default {
  // 取得QR Code行銷活動資料
  getQrCodeActivity(param, headers) {
    return ajaxServiceByApiGateway.get('/getqrcodeactivityv1', param, headers);
  },
  // 新增QRCODE行銷活動掃描紀錄資料
  postQrCodeScanningLog(body, headers) {
    return ajaxServiceByApiGateway.post('/postqrcodescanninglogv1', body, headers);
  },
  // QRCODE行銷活動發送Line訊息
  postQrCodeLineMessage(body) {
    return ajaxServiceByApiGateway.post('/postqrcodelinemessagev1', body);
  },
  // 新增QRCODE行銷活動未完成事項
  createQrCodePendingJob(body) {
    return ajaxServiceByApiGateway.post('/createqrcodependingjobv1', body);
  },
  // 新增QRCODE行銷活動訊息點擊紀錄
  createQRCodeMessageClick(body) {
    return ajaxServiceByApiGateway.post('/createqrcodemessageclickv1', body);
  },
  // QRCODE發信
  postSendMail(body) {
    return ajaxServiceByApiGateway.post('/postsendmailv1', body);
  },
};
